<template>
  <div>
    <Row justify="start" type="flex">
      <Col class="buy_col01" v-for="(item, index) in photoArr1" :key="index">
        <div class="buy_rule" @click="getMoney(item)">
          <img :src="item.photoUrl" alt="#" />
        </div>
        <div @click="getMoney(item)" class="sp">{{ item.ref }}</div>
        <div style="font-size: 18px; color: #f12344; margin-bottom: 6px">
          <!--{{item.money}}-->
          <Button type="primary" @click="getMoney(item)">了解更多</Button>
        </div>
      </Col>
    </Row>
    <!--对话框-->
    <div>
      <Modal
        class="modal_div"
        v-model="modal1"
        :title="ref"
        width="830px"
        class-name="vertical-center-modal"
        @on-visible-change="onChange"
      >
        <div slot="header">
          <Row>
            <Col span="20">
              <span class="header_div">{{ this.ref }}</span>
            </Col>
          </Row>
        </div>
        <div class="wid_img">
          <div style="border: 1px solid #ccc; border-radius: 5px">
            <video
              v-if="item01.type == 2"
              id="videoId"
              width="364px"
              height="300"
              :src="item01.videoUrl"
              autoplay
              muted
            ></video>
            <img
              v-else-if="item01.type == 1"
              :src="item01.photoUrl"
              alt="暂无图片"
            />
          </div>
          <div class="Introduction">
            <div class="Introduction__p">介 绍：{{ item01.p }}</div>
            <div class="phone">
              咨询电话: <span style="color: #1966ff"> 18001306738</span>
            </div>
          </div>
        </div>
        <div slot="footer">
          <Button @click="modal1 = false">取消</Button>
        </div>
      </Modal>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      modal1: false,
      item01: [],
      ref: "",
      photoArr1: [
        // 三维立体展示柜
        {
          photoUrl: "../../../static/img/photo/interaction.png",
          p: "利用VR技术沉浸感与计算机交互功能和多体感表现功能，高度还原事故场景，解决传统安全培训中抽象、纯理论、无体感等问题。主要包含有VR工程事故，VR质量样板、消防逃生、消防实训、化工厂消防。",
          ref: "VR交互平台",
          type: 1,
        },
        {
          photoUrl: "../../../static/img/photo/Eggchair.jpg",
          p: "体验者坐在蛋仓内带上VR眼镜即可体验，平台搭配全歼内容进行上下左右的移动，模拟真实工作场景，沉浸式观看给体验者带来视觉、听觉等感官上的刺激体验，从而学习各种安全应对措施。建设工程质量关系到群众的切实利益与施工企业的生命。要保证工程施工质量，增强质量责任意识，要从施工过程的各个环节方面落实责任，全面推行质量保证体系。",
          ref: "VR蛋椅体验",
          type: 1,
        },
        {
          photoUrl: "../../../static/img/photo/photo_guizi.jpg",
          videoUrl: "../../../static/video/photo_guizi.mp4",
          p: "触摸互动透明屏展示柜是一种将透明屏幕技术应用到展示柜中的新型产品。它可以在保持展示物品透明性的同时，通过触摸实现交互式操作和信息展示效果。",
          ref: "三维立体展示柜",
          type: 2,
        },
        /*智慧滑轨屏*/
        {
          photoUrl: "../../../static/img/Buy/Electric/WisdomSlidingscreen.jpg",
          videoUrl: "../../../static/video/WisdomSlidingscreen.mp4",
          p: "互动滑轨屏又称滑轨电视，形成结构由电子显示屏幕、轨道、红外感应器、主机、电机等组成，显示屏可左右上下控制,安装形式多样，电子屏幕移动到预定定位时，将会显示播放对应的素材内容与背景形成鲜明呼应，并与观众产生互动。-体机、 拼接屏等不同显示设备,具体可根据客户需求定制。互动滑轨屏提供软件功能，可在电子屏幕上根据手指的动作放大.旋转、缩小等。",
          ref: "互动滑轨屏",
          type: 2,
        },
        /*互动电子沙盘*/
        {
          photoUrl: "../../../static/img/Content/Interaction/Interaction01.png",
          videoUrl: "../../../static/video/Interaction01.mp4",
          p: "由触控屏和显示屏组成，触控屏用于信息化操作，显示屏用于信息化展示，当体验展示漫游模块时，通过操控令牌的移动，切换显示屏上立体空间的转换。此外，体验者可根据自己的需求，在我们提供的标准内容之外，自行添加想要的图文、视频，乃至PPT解析。-体机、 拼接屏等不同显示设备,具体可根据客户需求定制。互动滑轨屏提供软件功能，可在电子屏幕上根据手指的动作放大.旋转、缩小等。",
          ref: "互动电子沙盘",
          type: 2,
        },
        /*全息实景沙盘体验*/
        {
          photoUrl: "../../../static/img/Buy/Electric/shapan.jpg",
          videoUrl: "../../../static/video/shapan.mp4",
          p: "全息实景沙盘是将全息技术与传统实景沙盘相结合的创新展示方式。通过全息投影技术，在实景沙盘的基础上，实时叠加动态的三维全息影像，使得展示内容更加生动立体。观众不仅可以直观地观察沙盘中的建筑布局、地形地貌等实体部分，还能通过全息影像看到未来规划、建筑过程、交通流动等动态信息。这种结合大大增强了展示效果，为项目规划、建筑设计、以及城市发展提供了更加全面、互动的可视化体验。...",
          ref: "全息实景沙盘体验",
          type: 2,
        },
        /*全息投影系统*/
        {
          photoUrl: "../../../static/img/Buy/Electric/quanxi.png",
          p: "全息投影系统将三维画面悬浮在实景的半空中成像，营造了亦幻亦真的氛围，效果奇特具有强烈的纵深感，真假难辩。时尚美观，有科技感:顶端透明，色彩鲜艳，对比度，清晰度高:有空间感，透视感，形成空中幻象:中间可结合实物，实现影像与实物的结合;也可配加触摸屏实现与观众的互动。",
          ref: "全息投影系统",
          type: 1,
        },
        /*互动投影*/
        {
          photoUrl: "../../../static/img/Buy/Electric/touying.jpg",
          videoUrl: "../../../static/video/touying.mp4",
          p: "以大屏幕投影画面显示技术为主，应用现代遥感科技与多媒体处理技术将人的实体形象影响与投影机显示画面产生交互，也可以通过实景与投影画面展示出更加沉浸的效果。主要用于项目展示，产品展示。",
          ref: "互动投影",
          type: 2,
        },
        /*灵动屏*/
        {
          photoUrl: "../../../static/img/Buy/Electric/lingdongping.png",
          videoUrl: "../../../static/video/lingdongping.mp4",
          p: "灵动屏交互系统是一种将声光电技术巧妙结合的新型展示系统。用户通过触控按钮，灯带会随着按钮的激活逐步亮起，光流延展至屏幕后，自动播放与按钮对应的相关视频、图片或介绍内容。这种流畅的互动效果不仅提升了展示的科技感和吸引力，还为观众提供了一种直观且沉浸式的体验，让信息传递更加生动、引人入胜。",
          ref: "灵动屏",
          type: 2,
        },
        /*量子屏展示系统*/
        {
          photoUrl: "../../../static/img/Buy/Electric/liangzi.jpg",
          videoUrl: "../../../static/video/liangzi.mp4",
          p: "量子屏是一种先进的显示技术，广泛应用于建筑领域，能够将高清图像和信息无缝集成到建筑表面或室内空间中。通过量子屏技术，建筑物外立面或内部墙面可以变成动态展示平台，显示实时数据、建筑设计图纸、施工进度、以及其他可视化内容。其超高的分辨率和亮度使得即使在强光下也能清晰呈现内容。此外，量子屏还具备灵活性，可以根据建筑需求进行定制，实现建筑与信息展示的完美融合。这种技术不仅提升了建筑的智能化和现代感，还为建筑设计、施工展示和项目宣传提供了全新的解决方案。",
          ref: "量子屏",
          type: 2,
        },
      ],
    };
  },
  methods: {
    onChange() {
      document
        .querySelector("body")
        .setAttribute("style", "overflow:hidden;padding-right:15px");
    },
    /*弹出对话框*/
    getMoney(item) {
      this.modal1 = true;
      this.item01 = item;
      this.ref = item.ref;
    },
  },
};
</script>
<style>
.modal_div .ivu-modal-header p,
.modal_div .ivu-modal-header-inner {
  color: #02a0e7;
  font-size: 20px;
  font-weight: bold;
  font-family: 新宋体, serif;
}

/*面包屑*/
.col_bread .ivu-breadcrumb {
  font-size: 16px;
}
</style>
<style scoped>
/*弹出框字体*/
.header_div {
  color: #02a0e7;
  font-size: 20px;
  font-weight: bold;
  font-family: 新宋体, serif;
}

.font_size {
  font-size: 19px;
}

.buy_col01 {
  width: 270px;
  background: #ffff;
  text-align: center;
  cursor: pointer;
  margin: 14px 0px 0 22px;
}

.buy_col01 .sp:hover {
  color: red;
}

.buy_rule {
  width: 270px;
  height: 240px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.buy_rule img {
  width: 210px;
  height: 210px;
}

.sp {
  font-size: 14px;
  height: 40px;
}

.wid_img {
  display: flex;
  /* justify-content: center; */
  align-items: center;
}

.wid_img img {
  width: 364px;
  height: 330px;
}

.Introduction {
  width: 364px;
  height: 263px;
  margin-left: 15px;
}

.Introduction__p {
}

.buy_col01 {
  border-radius: 6px;
  width: 270px;
  background: #ffff;
  text-align: center;
  cursor: pointer;
  margin: 14px 0px 0 22px;
  box-shadow: 0 0 2px 2px rgba(0, 0, 0, 0.2);
  border-radius: 6px;
}

.buy_col01:hover {
  box-shadow: 0 0 3px 3px rgba(0, 0, 0, 0.2);
}

.buy_col01 .sp:hover {
  color: red;
}

.phone {
  margin-top: 5%;
}
</style>



// WEBPACK FOOTER //
// src/components/Buy/Interaction.vue